import {useContext} from 'react'
import SessionContext from 'context/SessionContext'

// Our hook
export default function useCurrentUser() 
{
  return useContext(SessionContext)?.me || null
}

